// Analytics Actions
// eslint-disable-next-line import/no-cycle -- Fix me (MC-1580)
import { UI_EVENT_TYPE } from "./types";
export var makeEventContainer = function makeEventContainer(v) {
  return v;
};
export var EVENT_CONTAINER_CLOUD_FORTIFIED_INFO_MODAL = makeEventContainer('cloudFortifiedInfoModal');
export var EVENT_CONTAINER_CLOUD_FORTIFIED_TOOLTIP = makeEventContainer('cloudFortifiedTooltip');
export var EVENT_CONTAINER_CERTIFICATION_SECTION = makeEventContainer('certificationSection'); // Analytics Actions

export var makeAnalyticsAction = function makeAnalyticsAction(v) {
  return v;
};
export var ANALYTICS_ACTION_CLICKED = makeAnalyticsAction('clicked');
export var ANALYTICS_ACTION_COLLAPSED = makeAnalyticsAction('collapsed');
export var ANALYTICS_ACTION_EXPANDED = makeAnalyticsAction('expanded');
export var ANALYTICS_ACTION_FETCH_FAILED = makeAnalyticsAction('fetchFailed');
export var ANALYTICS_ACTION_REMOVED = makeAnalyticsAction('removed');
export var ANALYTICS_ACTION_REMOVE_FAILED = makeAnalyticsAction('removeFailed');
export var ANALYTICS_ACTION_RENDERED = makeAnalyticsAction('rendered');
export var ANALYTICS_ACTION_SUBMITTED = makeAnalyticsAction('submitted');
export var ANALYTICS_ACTION_CHANGED = makeAnalyticsAction('changed');
export var ANALYTICS_ACTION_TOGGLED = makeAnalyticsAction('toggled'); // Analytics Action Subjects

export var makeAnalyticsActionSubject = function makeAnalyticsActionSubject(v) {
  return v;
};
export var ANALYTICS_SUBJECT_FORM_FIELD = makeAnalyticsActionSubject('formField');
export var ANALYTICS_SUBJECT_APP = makeAnalyticsActionSubject('app');
export var ANALYTICS_SUBJECT_BREADCRUMB = makeAnalyticsActionSubject('breadcrumb');
export var ANALYTICS_SUBJECT_BUTTON = makeAnalyticsActionSubject('button');
export var ANALYTICS_SUBJECT_LINK = makeAnalyticsActionSubject('link');
export var ANALYTICS_SUBJECT_MENU = makeAnalyticsActionSubject('menu');
export var ANALYTICS_SUBJECT_MENU_ITEM = makeAnalyticsActionSubject('menuItem');
export var ANALYTICS_SUBJECT_TAB = makeAnalyticsActionSubject('tab');
export var ANALYTICS_SUBJECT_LOZENGE = makeAnalyticsActionSubject('lozenge');
export var ANALYTICS_SUBJECT_TILE = makeAnalyticsActionSubject('tile');
export var ANALYTICS_SUBJECT_TILES = makeAnalyticsActionSubject('tiles');
export var ANALYTICS_SUBJECT_UI = makeAnalyticsActionSubject('ui');
export var ANALYTICS_SUBJECT_SEARCH = makeAnalyticsActionSubject('search');
export var ANALYTICS_SUBJECT_FILTER = makeAnalyticsActionSubject('filter');
export var ANALYTICS_SUBJECT_RADIO = makeAnalyticsAction('radioButton'); // Analytics Category Names

export var makeAnalyticsCategory = function makeAnalyticsCategory(v) {
  return v;
};
export var ButtonClickedEvent = {
  action: ANALYTICS_ACTION_CLICKED,
  actionSubject: ANALYTICS_SUBJECT_BUTTON,
  details: 'User clicked a button',
  type: UI_EVENT_TYPE
};
export var LinkClickedEvent = {
  action: ANALYTICS_ACTION_CLICKED,
  actionSubject: ANALYTICS_SUBJECT_LINK,
  details: 'User clicked a link',
  type: UI_EVENT_TYPE
};
export var RadioButtonToggledEvent = {
  action: ANALYTICS_ACTION_TOGGLED,
  actionSubject: ANALYTICS_SUBJECT_RADIO,
  details: 'User toggled pricing option',
  type: UI_EVENT_TYPE
};
export var TileClickedEvent = {
  action: ANALYTICS_ACTION_CLICKED,
  actionSubject: ANALYTICS_SUBJECT_TILE,
  details: 'User clicked a tile',
  type: UI_EVENT_TYPE
};
export var MenuExpandedEvent = {
  action: ANALYTICS_ACTION_EXPANDED,
  actionSubject: ANALYTICS_SUBJECT_MENU,
  details: 'User expanded a menu',
  type: UI_EVENT_TYPE
};
export var MenuItemClickedEvent = {
  action: ANALYTICS_ACTION_CLICKED,
  actionSubject: ANALYTICS_SUBJECT_MENU_ITEM,
  details: 'User clicked a menu item',
  type: UI_EVENT_TYPE
};
export var BreadcrumbClickedEvent = {
  action: ANALYTICS_ACTION_CLICKED,
  actionSubject: ANALYTICS_SUBJECT_BREADCRUMB,
  details: 'User clicked a breadcrumb item',
  type: UI_EVENT_TYPE
};
export var SearchSubmittedEvent = {
  action: ANALYTICS_ACTION_SUBMITTED,
  actionSubject: ANALYTICS_SUBJECT_SEARCH,
  details: 'When a search input is submitted',
  type: UI_EVENT_TYPE
};
export var FilterClickedEvent = {
  action: ANALYTICS_ACTION_CLICKED,
  actionSubject: ANALYTICS_SUBJECT_FILTER,
  details: 'User has selected a filter for the app search',
  type: UI_EVENT_TYPE
};
export var TabClickedEvent = {
  action: ANALYTICS_ACTION_CLICKED,
  actionSubject: ANALYTICS_SUBJECT_TAB,
  details: 'User clicked a tab',
  type: UI_EVENT_TYPE
};
export var LozengeClickedEvent = {
  action: ANALYTICS_ACTION_CLICKED,
  actionSubject: ANALYTICS_SUBJECT_LOZENGE,
  details: 'User clicked a lozenge',
  type: UI_EVENT_TYPE
};